/** @format */

import {styled} from '@mui/material/styles';
import {Box, Button, Typography} from '@mui/material';

export const Root = styled(Box)(() => ({
  position: 'relative',
  cursor: 'default',
  userSelect: 'none',
}));

export const Border = styled(Box)(() => ({
  borderRadius: '8px',
  border: '1px solid #3E88C5',
  width: '100%',
  height: '100%',
  position: 'absolute',
  left: 0,
  top: 0,
  zIndex: 1,
}));

export const TimerBg = styled(Box)(() => ({
  borderRadius: '8px 0 0 8px',
  width: 'calc(100% - 104px)',
  height: '100%',
  position: 'absolute',
  left: 0,
  top: 0,
  zIndex: 0,
  background: 'radial-gradient(100% 100% at 0% 100%, #6D3D26 0%, #141418 100%)',
}));

export const Content = styled(Box)(() => ({
  position: 'relative',
  zIndex: 2,
  display: 'flex',
}));

interface TextBoxProps {
  isExpired: boolean;
}

export const LeftBlock = styled(Box, {
  shouldForwardProp: prop => prop !== 'isExpired',
})<TextBoxProps>(({theme, isExpired}) => ({
  height: '48px',
  padding: theme.spacing(0, 2),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',

  p: {
    color: isExpired ? '#B17629' : '#FAFBFE',
  },
}));

export const TrialText = styled(Typography)(() => ({
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
  textAlign: 'left',
}));

export const BottomBlock = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),

  img: {
    transform: 'translateY(-2px)',
  },
}));

export const BottomBlockText = styled(Typography)(() => ({
  fontSize: '12px',
  fontWeight: 600,
  lineHeight: '14px',
  letterSpacing: '0.24px',
}));

export const TariffsButton = styled(Button)(() => ({
  position: 'relative',
  width: '113px',
  height: '48px',
  minWidth: 'unset',
  borderRadius: '8px',
  overflow: 'hidden',
  padding: 0,
  background: 'linear-gradient(80deg, #3E88C5 0%, #8F74C7 100%)',
}));

interface TariffsProps {
  hover: boolean;
}

export const TariffsButtonContent = styled(Box, {
  shouldForwardProp: prop => prop !== 'hover',
})<TariffsProps>(({theme, hover}) => ({
  position: 'absolute',
  zIndex: 1,
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(0, 2),

  '.MuiSvgIcon-root': {
    color: '#FBFBFE',
    transition: '0.2s',
    transform: `translateX(${hover ? '4px' : '0'})`,
  },
}));

export const TariffsButtonHover = styled(Box, {
  shouldForwardProp: prop => prop !== 'hover',
})<TariffsProps>(({theme, hover}) => ({
  position: 'absolute',
  zIndex: 0,
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: theme.palette.figma_primary?.dark,
  opacity: hover ? 0.5 : 0,
  transition: '0.2s',
}));

export const TariffsButtonText = styled(Typography)(() => ({
  color: '#FBFBFE',
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '20px',
  letterSpacing: '0.16px',
}));
